import { useEffect, useState } from 'react';

// Returns true when the document is ready
// https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
export function useReadyState(): boolean {
  const [isDocumentReady, setIsDocumentReady] = useState(false);

  useEffect(() => {
    const handleReadyStateChange = () => {
      if (document.readyState === 'complete') setIsDocumentReady(true);
    };

    if (!isDocumentReady) handleReadyStateChange();
  }, [isDocumentReady]);

  return isDocumentReady;
}

/**
 * Determines if the page is ready based on the user's login status.
 * This function ensures, for example, that the pagination will work correctly when
 * it is in view immediately on page load.
 */
export function useIsReadyBasedOnLoginStatus(
  isLoggedIn: boolean | null | undefined
): boolean {
  const shouldInitiallyBeReady: boolean = typeof isLoggedIn === 'undefined';

  const [ready, setReady] = useState(shouldInitiallyBeReady);

  useEffect(() => {
    if (shouldInitiallyBeReady || isLoggedIn === null) return;

    setTimeout(() => {
      requestAnimationFrame(() => {
        setReady(true);
      });
    }, 100);
  }, [isLoggedIn]);

  return ready;
}
